import $ from 'jquery';

let scrollOffset = 20;

calculateMenuPosition();
$(window).on('scroll', function() {
    calculateMenuPosition();
});

function calculateMenuPosition() {
    if($(window).scrollTop() > $('.main-content').offset().top - scrollOffset && $(window).scrollTop()) {

        if($(window).scrollTop() < $('.main-content').offset().top + $('.main-content').height() - $('.subpage-menu').height() - scrollOffset) {
            $('.subpage-menu').addClass('subpage-menu--fixed');
            $('.subpage-menu').removeClass('subpage-menu--fixed-bottom');
        } else {
            $('.subpage-menu').removeClass('subpage-menu--fixed');
            $('.subpage-menu').addClass('subpage-menu--fixed-bottom');
        }
    } else {
        $('.subpage-menu').removeClass('subpage-menu--fixed');
        $('.subpage-menu').removeClass('subpage-menu--fixed-bottom');
    }
}
